module.exports = __webpack_public_path__ + "static/media/workout.36e5dbde.jpg";